import instance from '../scorpiusInstance';
import {
  DELETE_APP_CIDR_START,
  DELETE_APP_CIDR_SUCCESS,
  DELETE_APP_CIDR_ERROR,
} from '../types';

export const deleteAppCIDRStart = (orgId, appName) => ({
  type: DELETE_APP_CIDR_START,
  orgId,
  appName,
});

export const deleteAppCIDRSuccess = (orgId, appName, cidrID) => ({
  type: DELETE_APP_CIDR_SUCCESS,
  orgId,
  appName,
  cidrID,
});

export const deleteAppCIDRError = (orgId, appName, error) => ({
  type: DELETE_APP_CIDR_ERROR,
  orgId,
  appName,
  error,
});

/**
 * Delete a CIDR record for an organization
 * @param {String} orgId - The organization's ID
 * @param {String} appName
 * @param {number} cidrID - ID of the CIDR address record
 */
export const deleteAppCIDR = (orgId, appName, cidrID) => async dispatch => {
  dispatch(deleteAppCIDRStart(orgId, appName));
  try {
    await instance.delete(`/organizations/${orgId}/cidrs/${cidrID}`, {
      headers: { retry: true },
    });
    return dispatch(deleteAppCIDRSuccess(orgId, appName, cidrID));
  } catch (error) {
    throw dispatch(deleteAppCIDRError(orgId, appName, error));
  }
};

export default deleteAppCIDR;
